import cx from 'classnames';
import styles from './RatingMark.module.scss';

export type RatingMarkProps = {
  className?: string;
  value: number;
  isOrange?: boolean;
};

export const RatingMark = ({className, value, isOrange}: RatingMarkProps) => {
  return (
    <div className={cx(styles.container, className)}>
      <svg viewBox="1 0 112 24" className={styles.rating}>
        <defs>
        <polygon id="star" points=" 12.4135,17.8812 17.1419,20.8769 18.3173,19.9847 16.9512,14.6108 16.9643,14.1564 17.2172,13.7787 21.4573,10.2496 21.0111,8.81481 15.4738,8.45544 15.0613,8.30317 14.7943,7.95382 12.7292,2.7532300000000003 12.443,2.38802 12,2.25 11.557,2.38802 11.2708,2.7532300000000003 9.20568,7.95382 8.93868,8.30317 8.52618,8.45544 2.98894,8.81481 2.54272,10.2496 6.78278,13.7787 7.03566,14.1564 7.0488,14.6108 5.78188,19.5945 7.19243,20.6651 11.586500000000001,17.8812 12,17.7607 12.4135,17.8812"></polygon>

          <clipPath id="stars">
            <use xlinkHref="#star"/>
            <use xlinkHref="#star" x="20%"/>
            <use xlinkHref="#star" x="40%"/>
            <use xlinkHref="#star" x="60%"/>
            <use xlinkHref="#star" x="80%"/>
          </clipPath>
        </defs>

        <rect className={styles.ratingBackground} clipPath="url(#stars)"></rect>
        <rect width={`${100 / 5 * value}%`} className={isOrange ? styles.ratingValueOrange : styles.ratingValue} clipPath="url(#stars)"></rect>
      </svg>
    </div>
  );
};
